export default {"src":"/_next/static/media/dealer-finance.e3e93824.svg","height":38,"width":36};